import { LogoHeader } from "../parts/LogoHeader";
import { HStack, Input, Text, Button } from "@chakra-ui/react";
import { StyledButton } from "../../../components";
import { useRef, useState, useEffect } from "react";

const RESEND_TIME = 60;

export const SuccessfulSent = () => {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const inputRefs = useRef([]);
    const [timeLeft, setTimeLeft] = useState(60);

    useEffect(() => {
        const storedTime = localStorage.getItem("resend_timer");
        if (storedTime) {
            const diff = Math.floor((Date.now() - parseInt(storedTime)) / 1000);
            if (diff < RESEND_TIME) {
                setTimeLeft(RESEND_TIME - diff);
            }
        } else {
            startTimer();
        }
    }, []);

    useEffect(() => {
        if (timeLeft <= 0) {
            localStorage.removeItem("resend_timer");
            return;
        }
        const timer = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    localStorage.removeItem("resend_timer");
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, [timeLeft]);

    const startTimer = () => {
        const now = Date.now();
        localStorage.setItem("resend_timer", now);
        setTimeLeft(RESEND_TIME);
    };

    const handleResend = () => {
        startTimer();
    };

    const handleChange = (index, e) => {
        const value = e.target.value;
        if (!/^\d*$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value.slice(-1);
        setOtp(newOtp);

        if (value && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").slice(0, 6).replace(/\D/g, "");
        if (pasteData.length === 6) {
            setOtp(pasteData.split(""));
            inputRefs.current[5].focus();
        }
    };

    const onSubmit = () => {
    };

    return (
        <>
            <LogoHeader
                title="Request sent successfully!"
                text="We've sent a 6-digit confirmation code to your email. Please enter the code below to verify your request."
                textFontSize="body.sm"
            />
            <HStack spacing="10px" onPaste={handlePaste} w="338px">
                {otp.map((digit, index) => (
                    <Input
                        key={index}
                        ref={(el) => (inputRefs.current[index] = el)}
                        value={digit}
                        onChange={(e) => handleChange(index, e)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        maxLength={1}
                        textAlign="center"
                        width="48px"
                        height="48px"
                        fontSize="xl"
                        color="neutral.100"
                        border="2px solid"
                        backgroundColor="neutral.900"
                        borderColor="neutral.800"
                        _focus={{ borderColor: "blue.500", outline: "none" }}
                    />
                ))}
            </HStack>
            <HStack justifyContent="space-between" w="338px" color="neutral.500" mb={'38px'}>
                <Text>Didn't receive the code?</Text>
                <HStack>
                    <Text>{timeLeft > 0 ? `00:${timeLeft.toString().padStart(2, "0")}` : "00:00"}</Text>
                    <Button
                        onClick={handleResend}
                        isDisabled={timeLeft > 0}
                        colorScheme="blue"
                        variant="link">
                        Resend
                    </Button>
                </HStack>
            </HStack>
            <StyledButton width="full" maxW="565px" onClick={() => onSubmit(otp.join(""))}>
                Submit
            </StyledButton>
        </>
    );
};
